import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateDataset } from "../../../../redux/dataset/datasetSlice";
import SingleSpeaker from "./SingleSpeaker";
import swal from "sweetalert";

export default function SpeakerList() {
  const data = useSelector((state) => state.datasetSlice.dataset);
  const speakers = data.speakers;
  const [isEditing, setIsEditing] = useState(false);
  const [newSpeakerName, setNewSpeakerName] = useState("");
  const [showNewSpeakerInput, setShowNewSpeakerInput] = useState(false);
  const [sortedSpeakers, setSortedSpeakers] = useState(speakers);

  useEffect(() => {
    const sorted = [...speakers].sort();
    setSortedSpeakers(sorted);
  }, [speakers]);

  const dispatch = useDispatch();

  const handleAddNewSpeaker = () => {
    if (newSpeakerName) {
      if (!speakers.includes(newSpeakerName)) {
        dispatch(updateDataset({ speakers: [...speakers, newSpeakerName] }));
        setNewSpeakerName("");
        setShowNewSpeakerInput(false);
      } else {
        swal("Oops!", "Speaker with that name already exists", "warning");
      }
    } else {
      setShowNewSpeakerInput(true);
    }
  };

  return (
    <div className={styles.speakersWrapper}>
      <h3>Speakers</h3>
      <div className={styles.speakerList}>
        {sortedSpeakers.map((speaker, index) => (
          <SingleSpeaker speaker={speaker} isEditing={isEditing} key={index} />
        ))}
      </div>
      {isEditing ? (
        <div className={styles.editing}>
          <div className={styles.actionButtons}>
            {showNewSpeakerInput ? (
              <>
                <input
                  type="text"
                  placeholder="New speaker name"
                  value={newSpeakerName}
                  onChange={(e) => setNewSpeakerName(e.target.value)}
                  className={styles.hiddenInput}
                />
                <button
                  onClick={handleAddNewSpeaker}
                  className={styles.addSpeaker}
                >
                  Add
                </button>
              </>
            ) : (
              <button
                onClick={handleAddNewSpeaker}
                className={`${styles.addSpeaker} ${styles.full}`}
              >
                Add new speaker
              </button>
            )}
          </div>
          <button
            onClick={() => setIsEditing(false)}
            className={styles.save}
            disabled={showNewSpeakerInput ? true : false}
          >
            Save
          </button>
        </div>
      ) : data.transcript_status !== "COMPLETED" ? (
        <button
          className={styles.editBtn}
          onClick={() => {
            setIsEditing(true);
          }}
        >
          Edit
        </button>
      ) : null}
    </div>
  );
}
